import { Field, Form, Formik, FormikHelpers } from 'formik'
import { isEmpty } from 'lodash'
import React, { FC, ReactElement, useEffect } from 'react'
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { useHistory, useParams } from 'react-router'
import * as yup from 'yup'
import Button from '../../components/button'
import Input from '../../components/input'
import config from '../../config'
import { useAuth } from '../../hooks/auth'
import { obfuscateEmail } from '../../utils/obfuscateEmail'
import { RoutesEnum } from '../../utils/routesEnum'
import RegisterSkeleton from './skeleton'
import { Center, VerificationCode } from './style'

const schema = yup.object().shape({
  token: yup.string().min(4, 'Código inválido')
    .required('Código obrigatório')
})

const initialValues = {
  token: ''
}

const RegisterVerificationCode: FC = (): ReactElement => {
  const { validationChecker } = useParams<{ validationChecker: string }>()
  const { registerParams, register } = useAuth()
  const { executeRecaptcha } = useGoogleReCaptcha()
  const history = useHistory()

  useEffect(() => {
    if (isEmpty(registerParams)) {
      history.push(RoutesEnum.REGISTER)
    }
  }, [registerParams, history])

  const submit = async (
    values: typeof initialValues,
    helpers: FormikHelpers<typeof initialValues>
  ): Promise<void> => {
    helpers.setSubmitting(true)
    try {
      const captcha = executeRecaptcha ? await executeRecaptcha() : undefined

      await register({
        ...registerParams,
        token: values.token,
        validationChecker
      }, captcha)

      history.push(RoutesEnum.PROCESS_EXAMS)
    } catch { }
    helpers.setSubmitting(false)
  }

  const informationEmail = 'Digite o código de 4 dígitos enviado para ' + obfuscateEmail(registerParams.email) + '.'

  return (
    <RegisterSkeleton>
      <Formik
        validationSchema={schema}
        initialValues={initialValues}
        onSubmit={submit}
      >
        {({ isSubmitting }) => (
          <Form>
            <Center>
              <p><b>Verificação de segurança</b></p>
              <span>Conclua a verificação a seguir para proteger a sua conta.</span>
            </Center>
            <VerificationCode>
              <Field
                label='Código de verificação e-mail'
                info={informationEmail}
                component={Input}
                name='token'
                maxLength={4}
              />
            </VerificationCode>
            <div className='buttons'>
              <Button type='submit' isLoading={isSubmitting} block>ENVIAR</Button>
              <br />
              <Button
                onClick={() => history.goBack()}
                block
                type='button'
                variant='link'
              >
                Não recebeu o código? Enviar novamente!
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </RegisterSkeleton>
  )
}

const RegisterVerificationCodeWithReCaptcha: FC = (props): ReactElement => {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={config.RECAPTCHA_TOKEN}>
      <RegisterVerificationCode {...props} />
    </GoogleReCaptchaProvider>
  )
}

export default RegisterVerificationCodeWithReCaptcha
